import SustainabilityDataService from '@/services/SustainabilityDataService'

export default {
  data() {
    return {
      pastInputs: {},
    }
  },
  methods: {
    async executeContextValidation() {
      // Only do a threshold validation when the acceptableInputDeviation is set
      if (this.item.acceptableInputDeviation || this.item.acceptableInputDeviation === 0) {
        const containsError = this._containsThresholdValidationError()
        // Try to remove the failed context validation entry from the store, if exists
        if (!containsError) {
          await this.removeFailedContextValidation(this.item.id)
        }
        return containsError
      }
      return undefined
    },
    async handleContextValidationError(isSaveAllOriginated) {
      await this._handleThresholdValidationError(isSaveAllOriginated)
    },
    async _containsThresholdValidationError() {
      // Always fetch pastInputs so that we compare to the current data
      this.pastInputs = (await SustainabilityDataService.getPreviousGridData(this.item)).data

      const latestPastInput = this._getLatestPastInput()

      // Check if the value fits inside the set threshold
      const isWithinThreshold = this._isWithinThreshold(
        this.$refs.input.inputValueToCompare,
        latestPastInput,
        this.item.acceptableInputDeviation,
      )

      if (!isWithinThreshold && !this.item.commentsExists) {
        this.tileValidationMessage = this.$t('VariesTooMuch')
        return true
      }
      this.tileValidationMessage = ''
      return false
    },
    _getLatestPastInput() {
      const timePeriodsInOrder = this.pastInputs.columns
        .map((column) => column.timePeriodId)
        .filter((column) => !!column)
        .slice(0, -1)
        .reverse()

      const previousData = this.pastInputs?.inputs[0]?.timePeriodValues
      let latestPastInput

      timePeriodsInOrder.some((timePeriod) => {
        if (previousData[timePeriod]) {
          latestPastInput = previousData[timePeriod]
          return true
        }
        return false
      })

      return latestPastInput
    },
    _isWithinThreshold(currentValue, previousValue, acceptableDeviation) {
      const acceptableDifference = Math.abs((previousValue / 100) * acceptableDeviation)

      const tooLow = currentValue < previousValue - acceptableDifference
      const tooHigh = currentValue > previousValue + acceptableDifference
      return !(tooLow || tooHigh)
    },
    async _handleThresholdValidationError(isSaveAllOriginated) {
      this.saveFailed = true
      this.isLoading = false
      await this.addFailedSave()
      await this.addFailedContextValidation(this.item.id)
      if (!isSaveAllOriginated) {
        this.showInformationDialog = true
      }
    },
  },
}
